import { getCookie } from "cookies-next";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authenticateOz } from "../services/ozservices";

const PageLayout = () => {
  useEffect(() => {
    const token = getCookie("access_token");

    if (!token) {
      authenticateOz();
      console.log("Authenticated");
    }
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main className="w-full mt-[72px]">
        <Outlet />
      </main>
    </div>
  );
};

export default PageLayout;
